import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React from 'react'
import { COUNTRY_NOT_AVAILABLE_KEY, MASTER_IS_OFFLINE_KEY } from 'src/Libs/dynamic-power-prices/const'
import SystemSettingsBlankView from 'src/Libs/system-settings/component/SystemSettingsBlankView'

interface Props {
  isServerOffline: boolean
  isAllowedInstallationLocation: boolean
}

/**
 * This component renders the blank view for the dynamic prices section of the system settings
 */
const FormBlankView: React.FC<Props> = ({ isServerOffline, isAllowedInstallationLocation }) => {
  const { t } = useCustomTranslation()

  const accordionTitle = t('systemSettings.price-based-charging.section-title')

  const blankViewVariant = isServerOffline ? 'error' : 'no-data'

  return (
    <OptionalTooltipWrapper
      hasTooltip={!isAllowedInstallationLocation || isServerOffline}
      placement={'top'}
      titleKey={isServerOffline ? MASTER_IS_OFFLINE_KEY : COUNTRY_NOT_AVAILABLE_KEY}
    >
      <AccordionItem
        expanded={isAllowedInstallationLocation && !isServerOffline}
        disabled={!isAllowedInstallationLocation || isServerOffline}
        title={accordionTitle}
      >
        <SystemSettingsBlankView variant={blankViewVariant} />
      </AccordionItem>
    </OptionalTooltipWrapper>
  )
}

export default FormBlankView
